import React, { useState } from "react";
import BaseBage from "../BasePage";
import { getVCI } from "../../api/FlaskAPI";
import vhiLegend from "../../assets/images/VHI.png";
import SignInComponent from "../../components/Sign/SignComponent";
import NavPageSelector from "../../components/NavPageSelector";
import CoordinatesInput from "../../components/CoordinatesInput";
import Map from "../Masking/Map";
import { toast } from "react-toastify";
import MonitoringDialog from "../Masking/MonitoringDialog";
import { useSelector } from "react-redux";

export default function VCI() {
  const [open, setOpen] = useState(false);
  const areas = useSelector((state) => state.mapState.areas);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <BaseBage
        dataKey="VCI_D"
        monitoringKey="vci"
        endpoint={getVCI}
        route="VCI"
        legendImg={{ src: vhiLegend, style: "vhi-legend-img" }}

      />
      {/* <div className="monitoring-container">
        <div className="map-wrapper">
          <NavPageSelector route={"vci"} />
          <div className="sign-up-container-base">
            <SignInComponent
              menuIconColor="black"
              backgroundColor="white"
              MT="0em"
              ML="0em"
              classN="modalcontainer-base"
            />
          </div>
          <CoordinatesInput disableFileUpload={false} />

          {/* <Map /> */}

      {/* side modal
          <div className="submit-compare-buttons-container">
            <button
              className="submit-compare-buttons"
              onClick={() => {
                if (!areas || !areas[0] || !areas[0].coordinates) {
                  toast.error(
                    "Please select the polygon you want to be predicted"
                  );
                } else {
                  handleOpen();
                }
              }}
            >
              Monitoring
            </button>
            <MonitoringDialog
              mainIndex="vci"
              open={open}
              handleClose={handleClose}
            />
          </div>
        </div>
      </div> */}
    </>
  );
}
